export const getPriceIndexFromRomeo = async ({
  artistId,
  currentYear = new Date().getFullYear(),
  fromYear = 5,
}: {
  artistId?: string
  currentYear?: number
  fromYear?: number
}): Promise<{ data: any; artistId: string }> => {
  let demandData = {}
  if (!artistId) return { data: {}, artistId: '' }

  const romeoUrl = `${
    process.env.NEXT_PUBLIC_ROMEO_API2_URL
  }/report/api/artist/priceindex/v2/${artistId}/?mxy=${currentYear}&mny=${
    currentYear - fromYear
  }`

  try {
    const romeoQuery = await fetch(romeoUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    demandData = romeoQuery.status === 200 ? await romeoQuery.json() : null
  } catch (err) {
    console.log('Error', err)
  }

  const dataItem = {
    artistId,
    data: demandData,
  }

  return dataItem ?? { data: {}, artistId }
}
